"use client";

import React from "react";
import {NotificationIcon} from "@/components/notifications/NotificationIcon";
import {NotificationItem} from "@/components/notifications/NotificationItem";
import {resolveAccountNotificationContent} from "@/components/notifications/notificationContent";
import type {NotificationDictionary} from "@/components/notifications/NotificationDrawer";
import type {Locale} from "@/i18n-config";
import type {
    ExportReadyNotification,
    ExportStartedNotification,
} from "@/utils/notifications/account/types";

type ExportAccountNotification =
    | ExportStartedNotification
    | ExportReadyNotification;

export function ExportNotification({
    notification,
    locale,
    dictionary,
    onMarkRead,
}: {
    notification: ExportAccountNotification;
    locale: Locale;
    dictionary: NotificationDictionary;
    onMarkRead: (notificationId: string) => void | Promise<void>;
}) {
    const content = resolveAccountNotificationContent(
        notification,
        locale,
        dictionary,
    );
    const ready = notification.type === "export_ready";

    return (
        <NotificationItem
            id={notification.id}
            locale={locale}
            publishedAt={notification.published_at}
            readAt={notification.read_at}
            icon={<NotificationIcon type={notification.type} />}
            label={content.category}
            title={content.title}
            description={content.description}
            sticky={notification.sticky}
            stickyLabel={dictionary.notificationCenterPinned}
            metadata={ready ? (
                <span className="break-all">
                    {notification.payload.fileName}
                </span>
            ) : undefined}
            action={ready ? (
                <a
                    href={`/api/exports/${notification.payload.reference.id}/download`}
                    onClick={() => onMarkRead(notification.id)}
                    className="text-sm font-semibold text-grass-700 hover:text-grass-900"
                >
                    {dictionary.notificationExportReadyAction}
                </a>
            ) : undefined}
            markReadLabel={dictionary.notificationCenterMarkRead}
            showMoreLabel={dictionary.notificationCenterShowMore}
            showLessLabel={dictionary.notificationCenterShowLess}
            onMarkRead={onMarkRead}
        />
    );
}
